module.exports = __webpack_public_path__ + "static/img/DreamStation_GO.1144d01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/escrowImg/DreamStation_GO.png
// module id = avnR
// module chunks = 1